import { render, staticRenderFns } from "./EditDatabaseConnection.vue?vue&type=template&id=53df5db2&"
import script from "./EditDatabaseConnection.vue?vue&type=script&lang=js&"
export * from "./EditDatabaseConnection.vue?vue&type=script&lang=js&"
import style0 from "./EditDatabaseConnection.vue?vue&type=style&index=0&id=53df5db2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports